import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./RegistryFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import RegistryFormStepOne from "./RegistryFormSteps/RegistryFormStepOne";
import { useState } from "react";
import { useEffect } from "react";

const RegistryForm = (props) => {
  const theme = useTheme();
  const { step, setStep, initialValues: init } = props;

  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    setInitialValues({
      ...init,
      defaultManager: { value: init?.defaultManager?.uuid },
    });
  }, [init]);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="RegistryForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <RegistryFormStepOne {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default RegistryForm;
